import { h, Fragment } from 'preact';
import { useProduct } from './product-context';
import './variant-selector-group.css';

const SwatchSelector = (props) => {
  const { currentSizeAvailable } = props;
  const { allProducts, activeProduct, handleProductChange, activeLength } =
    useProduct();
  const colorTitle = activeProduct.title.split(':')[1];
  const defaultHeading = TMW.Strings.product.swatchesDefaultHeading;
  const isMainOnSale = activeProduct.tags.find(
    (a) => a.includes('_Sale') || a.includes('_sale'),
  );
  const groupedByColorGroup = allProducts.reduce(
    (acc, product) => {
      let colorCategory = product.tags.find((a) =>
        a.includes('color-category'),
      );

      const isOnSale = product.tags.find(
        (a) => a.includes('_Sale') || a.includes('_sale'),
      );

      if (colorCategory !== undefined) {
        colorCategory = colorCategory.replace('color-category::', '');
      }

      const group = product.swatchGroup || colorCategory;
      if (!Boolean(group)) {
        if (!acc[defaultHeading]) acc[defaultHeading] = [];
        acc[defaultHeading].push(product);
        return acc;
      }

      if (!acc[group]) acc[group] = [];
      acc[group].push(product);

      return acc;
    },
    { [defaultHeading]: [] },
  );

  const groupedByColorGroupFiltered = groupedByColorGroup;
  const whiteishSwatches = props.variantsWhiteish
    ?.split(',')
    .map((value) => value.toLowerCase().trim());

  // Keep the default heading at the top
  const sortedKeys = Object.keys(groupedByColorGroupFiltered).sort((a, b) => {
    if (a === defaultHeading) return -1;
    if (b === defaultHeading) return 1;
    return a.localeCompare(b);
  });

  const handlePageReload = (handle) => {
    /* This is to solve Yotpo's BIS CTA not showing up when refreshing the section.
    Revert to handleProductChange(product.handle) on the onClick event when proper solution found */
    const newLocation = `/products/${handle}`;
    window.history.pushState({}, '', newLocation);
    window.location.href = newLocation;
  };

  const hasLength = allProducts[0].tags.find((tag) => tag.includes('length::'));
  return (
    <>
      {sortedKeys.map((group) => {
        if (!Boolean(groupedByColorGroupFiltered[group].length)) return null;

        return (
          <Fragment>
            <div className="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px]">
              {group}{' '}
              {groupedByColorGroupFiltered[group].some(
                (item) => item.handle === activeProduct.handle,
              ) && <span className="text-text-2 capitalize">{colorTitle}</span>}
            </div>
            <div className="flex items-center gap-0.5 flex-wrap mb-[30px] min-h-[40px]">
              {groupedByColorGroupFiltered[group].map((product) => {
                let variantAvailable = true;

                const selectedVariant = product.variants.edges.find(
                  (variant) =>
                    variant.node.title.split('/')[0].trim() ===
                    currentSizeAvailable,
                );
                if (selectedVariant) {
                  variantAvailable = selectedVariant.node.available;
                }

                const blackOutofStock = whiteishSwatches.includes(
                  product.variants.edges[0].node.selectedOptions[1].value.toLowerCase(),
                );

                return (
                  <button
                    className={`${
                      hasLength && !product.tags.includes(activeLength)
                        ? 'swatchButton hidden'
                        : 'swatchButton'
                    } ${variantAvailable ? '' : 'color-unavailable'}
                  ${blackOutofStock ? 'black-stroke' : ''}
                  `}
                  data-length={
                    product.tags.find((a) => a.includes('length'))
                    && product.tags.find((a) => a.includes('length'))
                  }
                  data-swatch={
                    product.variants.edges[0].node.selectedOptions[1].value
                  }
                  onClick={() => handlePageReload(product.handle)}
                >
                  <img
                    className={`rounded-full ${
                      activeProduct.handle === product.handle
                        ? 'border border-solid border-black p-0.5'
                        : 'border border-solid border-transparent p-0.5'
                    }`}
                    src={product.swatchUrl}
                  />
                </button>
                );
              })}
            </div>
          </Fragment>
        );
      })}
    </>
  );
};

export default SwatchSelector;
